import { StateSchema } from 'app/providers/StoreProvider';

export const getNotificationsIsActive = (state: StateSchema) =>
    state.notifications.isActive;
